import * as THREE from 'three';

// Parsed once per hex string: Color.set('#hex') runs a regex and allocates, too costly for per-frame and per-kill code.
// The returned colour is shared: copy it before changing it.
const cache = new Map<string, THREE.Color>();

export function rgb(hex: string): THREE.Color {
  let c = cache.get(hex);
  if (!c) cache.set(hex, (c = new THREE.Color(hex)));
  return c;
}
